import api from './api';

export const enseignantService = {
  // Récupérer tous les enseignants (admin)
  getAll: async (page = 1) => {
    try {
      const response = await api.get(`/admin/enseignants?page=${page}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des enseignants:', error);
      throw error;
    }
  },

  // Récupérer un enseignant par ID (admin)
  getById: async (id) => {
    try {
      const response = await api.get(`/admin/enseignants/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération de l\'enseignant:', error);
      throw error;
    }
  },

  // Créer un enseignant (admin)
  create: async (data) => {
    try {
      const response = await api.post('/admin/enseignants', data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création de l\'enseignant:', error);
      throw error;
    }
  },

  // Mettre à jour un enseignant (admin)
  update: async (id, data) => {
    try {
      const response = await api.put(`/admin/enseignants/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de l\'enseignant:', error);
      throw error;
    }
  },

  // Supprimer un enseignant (admin)
  delete: async (id) => {
    try {
      const response = await api.delete(`/admin/enseignants/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de l\'enseignant:', error);
      throw error;
    }
  },

  // Envoyer les identifiants à un enseignant
  envoyerIdentifiants: async (id, regenerer = false) => {
    try {
      const response = await api.post(`/admin/enseignants/${id}/envoyer-identifiants`, { regenerer });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'envoi des identifiants:', error);
      throw error;
    }
  }
};
